//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";

// custom pages
import { mpcDetailStyles } from "./styles";
import MPCApi from "apis/mpc/mpc";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import { useTranslation } from 'react-i18next';
// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function ViewShipTo(props) {
  const { state, dispatch } = useContext(Context);
  const { getMpcDetail, update } = MPCApi();
  const history = useHistory();
  const location = useLocation();
  const classes = mpcDetailStyles();
  const [mpc, setMpc] = useState({});
  const [data, setData] = useState({});
  const [dataClone, setDataClone] = useState({});
  const [updated, setUpdated] = useState({});
  const [edit, setEdit] = useState(false);
  const {t,i18n}=useTranslation()

  // setting mpc details
  // useEffect(() => {
  //   if (location.state && location.state.mpc) {
  //     setMpc(location.state.mpc);
  //     return;
  //   } else {
  //     history.goBack();
  //   }
  // }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "MPC Configurations"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (location?.state?.mpcId) {
      handleGet();
      return;
    }
    history.goBack();
  }, []);

  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.mpcId;
      let res = await getMpcDetail(id);
      if (res) {
        setData(res?.data);
        setDataClone(res?.data);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleUpdate = async () => {
    try {
      let arg = {};
      arg = { updated, id: data?.product_primary_class_id };
      let res = await update(arg);
      if (res) {
        setDataClone({ ...dataClone, ...res?.data });
        setEdit(false);
        history.push("/dashboard/upload-success", {
          type: "MPC data is updated to our system successfully.",
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  let editObj = {
    redemption_percentage: { edit: edit, type: "number" },
    is_active: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "Active" },
        { value: false, label: "Inactive" },
      ],
    },
    allow_points: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    allow_tier: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
  };

  let nameObj = {
    product_primary_class_id: "MPC ID",
    product_primary_class_description: "MPC description",
    primary_major_class_code: "Major",
    primary_major_class_code_description: "Major description",
    primary_submajor_class_code: "Sub major",
    primary_submajor_class_code_description: "Sub major description",
    primary_minor_class_code: "Primary Minor Class Code",
    primary_minor_class_code_description:
      "Primary Minor Class Code Description",
    is_active: "Status",
    allow_points: "Allow Points",
    allow_tier: "Allow Tier",
    redemption_percentage: "Redemption %",
    loyalty_organization_name: "Org name",
    loyalty_site_id: "Site name",
    loyalty_category_code: "Sales category",
  };

  let offset = location?.state?.offset;

  return (
    <React.Fragment>
      <Grid container style={{ padding: 10 }}>
        <Grid item xs={6}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.push("/dashboard/mpc", { offset });
            }}
          >
            {t('Back')}
          </Button>
        </Grid>
      </Grid>
      {/* <Grid container>
        {Object.keys(data)?.map((d, i) => (
          <Grid
            xs={6}
            style={{ padding: 10, fontSize: 18, alignSelf: "center" }}
          >
            {editObj[d]?.edit ? (
              editObj[d]?.type === "select" ? (
                <Grid container>
                  <Grid item xs={12}>
                    <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                      {nameObj[d]}&nbsp;:&nbsp;
                    </span>
                    <CssTextField
                      variant="outlined"
                      select
                      fullWidth
                      style={{ width: 200 }}
                      value={data?.[d]}
                      onChange={(e) => {
                        console.log({ d: data?.[d] });
                        console.log({ e: e.target.value });
                        setData({ ...data, [d]: e.target.value });
                        setUpdated({ ...updated, [d]: e.target.value });
                      }}
                    >
                      {editObj[d]?.options.map((r, i) => (
                        <MenuItem value={r.value} key={i}>
                          {r.label}
                        </MenuItem>
                      ))}
                    </CssTextField>
                  </Grid>
                </Grid>
              ) : (
                <Grid container>
                  <Grid item xs={12}>
                    <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                      {nameObj[d]}&nbsp;:&nbsp;
                    </span>
                    <CssTextField
                      fullWidth
                      variant="outlined"
                      type={editObj[d]?.type}
                      style={{ width: 200 }}
                      disabled={!edit}
                      value={data?.[d]}
                      onChange={(e) => {
                        if (editObj[d]?.type === "text") {
                          setData({ ...data, [d]: e.target.value });
                          setUpdated({ ...updated, [d]: e.target.value });
                        }
                        if (editObj[d]?.type === "number") {
                          setData({ ...data, [d]: parseInt(e.target.value) });
                          setUpdated({
                            ...updated,
                            [d]: parseInt(e.target.value),
                          });
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              )
            ) : (
              <div>
                <span style={{ fontWeight: "bold" }}>{nameObj[d]}</span> :{" "}
                {typeof data?.[d] == "boolean" ? (
                  data?.[d] ? (
                    <span
                      style={{
                        backgroundColor: "green",
                        borderRadius: 10,
                        color: "#fff",
                        padding: 5,
                        fontWeight: "bold",
                        letterSpacing: 1,
                        textAlign: "center",
                      }}
                    >
                      Active
                    </span>
                  ) : (
                    <span
                      style={{
                        backgroundColor: "red",
                        borderRadius: 10,
                        color: "#fff",
                        padding: 5,
                        fontWeight: "bold",
                        letterSpacing: 1,
                        textAlign: "center",
                      }}
                    >
                      Inactive
                    </span>
                  )
                ) : (
                  data?.[d]
                )}
              </div>
            )}
          </Grid>
        ))}
      </Grid> */}
      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('MPC Details')}</div>
        </div>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('MPC ID')}</span> :{" "}
            {data.product_primary_class_id}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('MPC description')}</span> :{" "}
            {data.product_primary_class_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Major class code')}</span> :{" "}
            {data.primary_major_class_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
              {t('Major class code description')}
            </span>{" "}
            : {data.primary_major_class_code_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Sub Major class code')}</span> :{" "}
            {data.primary_submajor_class_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
              {t('Sub Major class code description')}
            </span>{" "}
            : {data.primary_submajor_class_code_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Minor class code')}</span> :{" "}
            {data.primary_minor_class_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
             {t('Minor class code description')}
            </span>{" "}
            : {data.primary_minor_class_code_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Sales category')}</span> :{" "}
            {t(data.loyalty_category_code)}
          </div>
        </Grid>
      </Grid>

      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('MPC % Details')}</div>
        </div>
        <Grid xs={12} lg={6} className={classes.grid}>
          {editObj["is_active"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["is_active"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["is_active"]}
                  onChange={(e) => {
                    setData({ ...data, ["is_active"]: e.target.value });
                    setUpdated({ ...updated, ["is_active"]: e.target.value });
                  }}
                >
                  {editObj["is_active"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>{t('Status')} </span> :{" "}
              {typeof data?.["is_active"] == "boolean" ? (
                data?.["is_active"] ? (
                  <span className={classes.activeSpan}>{t('Active')}</span>
                ) : (
                  <span className={classes.inActiveSpan}>{t('Inactive')}</span>
                )
              ) : (
                data["is_active"]
              )}
            </div>
          )}
        </Grid>
        {state?.userInfo?.loyalty_organization_name=='Henry Schein Canada'&&
        <Grid xs={12} lg={6} className={classes.grid}>
          {editObj["allow_points"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["allow_points"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["allow_points"]}
                  onChange={(e) => {
                    setData({ ...data, ["allow_points"]: e.target.value });
                    setUpdated({ ...updated, ["allow_points"]: e.target.value });
                  }}
                >
                  {editObj["allow_points"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>{t('Allow Points')} </span> :{" "}
              {typeof data?.["allow_points"] == "boolean" ? (
                data?.["allow_points"] ? (
                  <span className={classes.activeSpan}>{t('Yes')}</span>
                ) : (
                  <span className={classes.inActiveSpan}>{t('No')}</span>
                )
              ) : (
                data["allow_points"]
              )}
            </div>
          )}
        </Grid>}
        {state?.userInfo?.loyalty_organization_name=='Henry Schein Canada'&&
        <Grid xs
        ={12} lg={6} className={classes.grid}>
          {editObj["allow_tier"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["allow_tier"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["allow_tier"]}
                  onChange={(e) => {
                    setData({ ...data, ["allow_tier"]: e.target.value });
                    setUpdated({ ...updated, ["allow_tier"]: e.target.value });
                  }}
                >
                  {editObj["allow_tier"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>{t('Allow Tier')} </span> :{" "}
              {typeof data?.["allow_tier"] == "boolean" ? (
                data?.["allow_tier"] ? (
                  <span className={classes.activeSpan}>{t('Yes')}</span>
                ) : (
                  <span className={classes.inActiveSpan}>{t('No')}</span>
                )
              ) : (
                data["allow_tier"]
              )}
            </div>
          )}
        </Grid>}
       
        <Grid xs={12} lg={4} className={classes.grid}>
          {editObj["redemption_percentage"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["redemption_percentage"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  fullWidth
                  variant="outlined"
                  type={editObj["redemption_percentage"]?.type}
                  className={classes.cssTextField}
                  disabled={!edit}
                  value={data?.["redemption_percentage"]}
                  onChange={(e) => {
                    if (editObj["redemption_percentage"]?.type === "text") {
                      setData({
                        ...data,
                        ["redemption_percentage"]: e.target.value,
                      });
                      setUpdated({
                        ...updated,
                        ["redemption_percentage"]: e.target.value,
                      });
                    }
                    if (editObj["redemption_percentage"]?.type === "number") {
                      setData({
                        ...data,
                        ["redemption_percentage"]: parseInt(e.target.value),
                      });
                      setUpdated({
                        ...updated,
                        ["redemption_percentage"]: parseInt(e.target.value),
                      });
                    }
                  }}
                />
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>{t('Redemption %')} </span> :{" "}
              {data.redemption_percentage}
            </div>
          )}
        </Grid>
        <Grid item xs={12} lg={2} className={classes.gridBtn}>
          <Grid item xs={12} lg={6}>
            {edit && (
              <Button
                className={classes.editCancelBtn}
                onClick={() => {
                  setData(dataClone);
                  setEdit(false);
                }}
              >
                {t('cancel')}
              </Button>
            )}
          </Grid>
          <Grid item xs={12} lg={6}>
            <Button
              className={classes.editBtn}
              onClick={()=>{
                if(state?.userInfo?.editAction){
                if (edit) {
                  if (Object.keys(updated).length > 0) {
                    handleUpdate();
                    return;
                  }
                  toast.error("Edit atleast one field.", {
                    toastId: "update-btn",
                  });
                } else {
                  setEdit(true);
                }
                return;
              }
            else{
              toast.error(state.userInfo?.editAccess)
            return;
          }}}
              // disabled={!access['editAccess'][state.userInfo?.role]['mpcdetail']}
            >
              {edit ? "Update" : "Edit"}
            </Button>
          </Grid>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Org name')}</span> :{" "}
            {t(data.loyalty_organization_name)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Site name')}</span> :{" "}
            {t(data.loyalty_site_id)}
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
